export default __webpack_public_path__ + "static/media/product-2-3.a096187a.jpg";